


















import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Toast extends Vue {
  @Prop({default: ''}) private heading!: string;
  @Prop({default: ''}) private body!: string;
  @Prop({default: true}) private showToastBoolean!: boolean;
  private mutableShowToastBoolean: boolean = true;

  private mounted() {
    setTimeout(() => {
      this.$emit('update:showToastBoolean', false);
      this.mutableShowToastBoolean = false;
    }, 10000);
  }
}
